module.exports = __webpack_public_path__ + "40be2695d1a2a136339a88bf6f5c337b.png";